import {
  Component,
  Host,
  h,
  Prop,
  Event,
  EventEmitter,
  State,
  Element,
} from '@stencil/core';
import { versionComponent } from '../../global/inject-dependencies';

declare let uc: any;
declare let UC_UI: any;

@Component({
  tag: 'ui-usercentrics-overlay',
  styleUrl: 'ui-usercentrics-overlay.scss',
  shadow: false,
})
export class UiUsercentricsOverlay {
  @Element() el: HTMLElement;

  @Prop() pid: string; // e. g. "S1pcEj_jZX" for Google Maps – see https://docs.usercentrics.com/#/smart-data-protector?id=currently-supported-technologies

  @State() consentStatus = false;

  @Event({ eventName: 'newConsentStatus' }) newConsentStatus: EventEmitter;

  services = {
    S1pcEj_jZX: 'googleMaps',
  };

  componentWillLoad() {
    /*
     uc.blockElements only works before the component is fully initialized,
     otherwise the element won't be blocked.
     */
    if (typeof uc !== 'undefined') {
      uc.blockElements({
        [this.pid]: `.ui-usercentrics-overlay--${this.pid}`,
      });
    }
  }

  /**
   * Using compWillLoad might cause event 'newConsentStatus' to be emitted BEFORE child components
   * had a chance to add their event listener. Using compDidLoad ensures that child components
   * have initialized and are READY to listen .
   */
  componentDidLoad() {
    // Fallback if usercentrics not available - works if UC is blocking script
    if (typeof uc === 'undefined') {
      this.newConsentStatus.emit({ [this.services[this.pid]]: true });
      return;
    }

    // Check if UC UI is initialized
    if (typeof UC_UI !== 'undefined' && UC_UI.isInitialized()) {
      this.setStatusAndStatusListener();
    } else {
      window.addEventListener('UC_UI_INITIALIZED', () => {
        this.setStatusAndStatusListener();
      });
    }
  }

  private setStatusAndStatusListener() {
    this.setAndEmitCurrentStatus();

    if (!this.consentStatus) {
      window.addEventListener('ucEvent', (event: any) => {
        if (
          event.detail &&
          event.detail.event === 'consent_status' &&
          typeof UC_UI !== 'undefined'
        ) {
          this.setAndEmitCurrentStatus();
        }
      });
    }
  }

  private setAndEmitCurrentStatus() {
    const service = UC_UI.getServicesBaseInfo().find(
      (el: any) => el.id === this.pid
    );
    this.consentStatus = service.consent?.status;
    this.newConsentStatus.emit({
      [this.services[this.pid]]: this.consentStatus,
    });
  }

  render() {
    return (
      <Host>
        <slot></slot>
        <div class={`ui-usercentrics-overlay--${this.pid}`}></div>
      </Host>
    );
  }
}

versionComponent(UiUsercentricsOverlay);
